// Toggle visibility on the scroll to top
(function($) {
	//Listen for scrolling
	maybeShowScrollToTop();

    $(window).scroll(function () {
		maybeShowScrollToTop();
    });

    function maybeShowScrollToTop() {
    	$('#to-top').toggleClass('clickable', $(document).scrollTop() > 120);
    }
	
})(jQuery);
